import React from 'react'
import { useCases } from '../../content/csp'

const UseCases = () => {
  return (
    <section className="csp-section csp-section--tint">
      <div className="container">
        <div className="row">
          <div className="col-lg-8">
            <span className="csp-kicker">{useCases.kicker}</span>
            <h2 className="csp-title">{useCases.title}</h2>
            <p className="csp-lead">{useCases.lead}</p>
          </div>
        </div>
        <div className="csp-grid csp-grid--2" style={{ marginTop: 40 }}>
          {useCases.items.map((item) => (
            <article className="csp-card csp-card--ruled" key={item.title}>
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}

export default UseCases
